import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.doneQuestion.loading;
export const doneQuestionErrorMessage = (state: RootState) =>
  state.doneQuestion.error;
export const doneQuestionResponseData = (state: RootState) =>
  state.doneQuestion.doneQuestionResponse;
